export default "__VITE_ASSET__DGwj2LdY__"